export {}

const selectLinkItems = document.querySelectorAll<HTMLElement>(".i-select-link")

selectLinkItems.forEach(item => {
  const placeholder = item.querySelector<HTMLElement>(".i-select-link__placeholder")

  placeholder?.addEventListener("click", () => {
    const lastLink = item.querySelector<HTMLElement>(".link:last-child")
    item.classList.toggle("--open")
    item.classList.toggle("--top", item.classList.contains("--open"))
    item.classList.remove("--bottom")

    if (lastLink) {
      const linkRect = lastLink.getBoundingClientRect()
      console.log(window.innerHeight <= linkRect.bottom)

      if (window.innerHeight <= linkRect.bottom) {
        item.classList.remove("--top")
        item.classList.add("--bottom")
      }
    }
  })
})

document.addEventListener("click", (e) => {
  const target = e.target
  if (target instanceof HTMLElement && !target.closest(".i-select-link"))
    selectLinkItems.forEach(item => item.classList.remove("--open"))
})
